import { makeStyles, css } from '@conexasaude/hero'

const useStyles = makeStyles({
  modalWrapper: () => css`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    div {
      margin-bottom: 16px;
    }

    p {
      width: 100%;
      margin-bottom: 24px;
    }
  `,

  illustration: () => css`
    @media (max-width: 639px) {
      width: 150px;
    }
  `,

  modalQuestionText: () => css`
    margin-bottom: 48px;
  `,
  footer: () => css`
    display: flex;
    justify-content: flex-end;
    width: 100%;

    @media (max-width: 639px) {
      flex-direction: column;
    }
  `,

  button: () => css`
    align-items: center;
    justify-content: center;
    display: flex;
    margin-left: 5px;
  `,
})

export { useStyles }
